import useModal from '../../../useModal';
import UseContext from '../../../../../hooks/useContext';
import Modalheader from '../../../components/header';
import ModalBody from '../../../components/body';
import ModalFooter from '../../../components/footer';
import Button from '../../../../button';

const ModalConfirmPaymentSettings = () => {
  const { toggle } = useModal();
  const { modalData, setModalDataReturn } = UseContext();

  const confirm = () => {
    setModalDataReturn({ type: 'payment_settings_confirmed', coefficients: modalData?.coefficients });
    toggle();
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Confirmer les paramètres de paiement
      </Modalheader>
      <ModalBody>
        <div className={'text-sm text-gray-500'}>
          Ces coefficients seront appliqués à la facturation de l’entreprise
          utilisatrice. Ils sont visibles par l’entreprise.
        </div>
      </ModalBody>
      <ModalFooter>
        <Button size={'LG'} color={'SECONDARY'} onClick={toggle}>
          Annuler
        </Button>
        <Button size={'LG'} color={'PRIMARY'} onClick={confirm}>
          Confirmer
        </Button>
      </ModalFooter>
    </>
  );
};

export default ModalConfirmPaymentSettings;
